<div class="ft2-password-validation-popup" *ngIf="rulesVisible" [@slideDown]="rulesVisible">
    <ft-validation-checklist [title]="'Your password must contain:'"
                             [rules]="rules" />
</div>
